import React from 'react';
import PropTypes from 'prop-types';
import {BlockPicker} from 'react-color';

@autobind
/**
 *
 */
export default class ColorPicker extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
    color: PropTypes.string,
    colors: PropTypes.array,
  };

  static defaultProps = {
    color: '#108ee9',
    colors: undefined
  };

  /**
   *
   * @return {XML}
   */
  render() {
    const {color, colors, onChange} = this.props;

    return (
      <BlockPicker
        width="100%"
        color={color}
        colors={colors}
        onChangeComplete={(color) => onChange(color)}
        triangle="hide"
        className="color-picker"
      />
    );
  }
}
